import { z } from "zod";

// Define the form schema with Zod
export const formSchema = z.object({
    order_details_id: z.number().int().positive("Order ID is required"),
    ack_no: z.string().min(1, "Acknowledgement number is required"),
    amount: z.number().positive("Amount must be greater than zero"),
    Payment_Proof: z.string().min(1, "Payment proof is required"),
    Supporting_document: z.string().optional(),
});

export type CapturePaymentFormValues = z.infer<typeof formSchema>;

export interface PaymentStatusRequest {
    payments_id: number;
    status: string;
    order_details_id: number;
}